<div class="document-viewer-container">
  <ng2-pdfjs-viewer #pdfViewerAutoLoad [showSpinner]="false"></ng2-pdfjs-viewer>
</div>
